// The 50 states and D.C. by name, abbreviation and URL slug, and nothing else.
//
// Split out of ./states (about 60KB of prose) for the code that runs on every page: the
// not-found page lists every state, and the redirect table maps "/ga" to "/states/georgia".
// states.test.ts checks this list against STATES so the two cannot drift.

export const STATE_ABBR_TO_NAME: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export interface StateIndexEntry {
  name: string;
  abbr: string;
  slug: string;
}

/** Every state and D.C., alphabetical by name, with the slug its page lives at. */
export const STATE_INDEX: readonly StateIndexEntry[] = Object.entries(STATE_ABBR_TO_NAME)
  .map(([abbr, name]) => ({ name, abbr, slug: name.toLowerCase().replace(/\s+/g, "-") }))
  .sort((a, b) => a.name.localeCompare(b.name));
